module.exports = __webpack_public_path__ + "static/media/IT-perfessional.ab65059b.jpg";